import { Outlet } from 'react-router-dom';

import SetupLayout from 'ui/SetupLayout';

const EmailView = () => (
  <SetupLayout>
    <Outlet />
  </SetupLayout>
);

export default EmailView;
